import {
  // BrowserRouter as Router,
  // Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { APP_ROUTES } from "./approutes";
import LoginForm from "../Components/Authentication/Login";
import ForgotPassword from "../Components/Authentication/ForgotPassword";
import Appointments from "../Components/Pages/Appointments";
import Payments from "../Components/Pages/Payments";
import Patients from "../Components/Pages/Patients";
import Settings from "../Components/Pages/Settings";
import ShareCall from "../Components/Pages/ConsultationNotes/VideoConsultation/ShareCall";
import SharePayment from "../Components/Pages/Payments/SharePayment";
import BillingReports from "../Components/Pages/BillingReports";
import PaymentInitiation from "../Components/Pages/PaymentInitiation";
import DietPaymentInitiation from "../Components/Pages/DietPaymentInitiation";
import MedPharma from "../Components/Pages/PharmaMed/MedPharma";
import LabPharma from "../Components/Pages/PharmaMed/LabPharma";
import OrderReport from "../Components/Pages/OrderReport";
import AutoLogin from "../Components/Authentication/AutoLogin";
import MobileLogin from "../Components/Authentication/MobileLogin";
import DirectLink from "../Components/Pages/PharmaMed/DirectLink";
import EmergencyQR from "../Components/Pages/ConsultationNotes/VitalTabs/MedicalHistory/EmergencyQR";
import HealthSummary from "../Components/Pages/HealthSummary";
import Notification from "../Components/Pages/Notifictation";
import Slot from "../Components/Pages/Slot";
import ReferTo from "../Components/Pages/Refaral/index";
import VideoConsult from "../Components/Pages/VideoConsultation/VideoConsult";
import NewDashboard from "../Components/Pages/NewDashboard/index";
import MappedClinics from "../Components/Pages/MappedClinics";
import AppointmentCalender from "../Components/Pages/UpcomingAppointments/AppointmentCalender";
import DirectJoinCall from "../Components/Pages/DirectLinks/DirectJoinCall";
import FavMedicine from "../Components/Pages/FavMedicine";
import DevicesSetup from "../Components/Pages/RPM/DeviceSetup";
import RpmBillingReport from "../Components/Pages/RPM/BillingReportRpm";
import VitalParameters from "../Components/Pages/RPM/VitalParameter";
import TaskFrequency from "../Components/Pages/RPM/TaskFrequency";
import RpmPatientPallette from "../Components/Pages/Patients/PatientPallette";
import PatientMonitor from "../Components/Pages/PatientMonitor";
import RpmDashboard from "../Components/Pages/RPM/RpmDashboard";
import RpmClinicalNotes from "../Components/Pages/Patients/PatientPallette/ClinicalNotes/addClinicalNote";
import RpmMedicalRecords from "../Components/Pages/Patients/PatientPallette/MedicalRecords/viewAll";
import ViewAllHistory from "../Components/Pages/Patients/PatientPallette/MedicalHistory/viewAllHistory";
import CallBackForm from "../Components/Pages/CallBackForm/CallBackForm";
import RequestAppointments from "../Components/Pages/AppointmentsRequest";
import Dietrician from "../Components/Pages/Dietrician/Index";
import DietPlan from "../Components/Shared/DietPlan/index";
import InPatients from "../Components/Pages/InPatients";
import InPatientsNew from "../Components/Pages/InPatientsNew";
import ICUWards from "../Components/Pages/ICUWards";
import OperationTheatre from "../Components/Pages/OperationTheatre";
import EmergencyPage from "../Components/Pages/Emergency";
import WardsPage from "../Components/Pages/Wards";
import Analytics from "../Components/Pages/Analytics";

const BASE = process.env.PUBLIC_URL || "";

const PageRouting = () => {
  return (
    // <Router>
    <Switch>
      <Route exact path={APP_ROUTES.LOGINFORM} component={LoginForm} />
      <Route exact path={APP_ROUTES.AUTHENTICATE} component={AutoLogin} />
      <Route exact path={APP_ROUTES.SHARECALL} component={ShareCall} />
      <Route exact path={APP_ROUTES.SHAREPAYMENTS} component={SharePayment} />
      <Route path={APP_ROUTES.FORGETPASSWORD} component={ForgotPassword} />
      <Route path={APP_ROUTES.DASHBOARD} component={NewDashboard} />
      <Route path={APP_ROUTES.APPOINTMENTS} component={Appointments} />
      <Route path={APP_ROUTES.ANALYTICS} component={Analytics} />
      <Route path={APP_ROUTES.PATIENTS} component={Patients} />
      <Route path={APP_ROUTES.PAYMENTS} component={Payments} />
      <Route path={APP_ROUTES.SETTINGS} component={Settings} />
      <Route path={APP_ROUTES.BILLINGREPORTS} component={BillingReports} />
      <Route path={APP_ROUTES.REFERTO} component={ReferTo} />
      <Route path={APP_ROUTES.DIRECTLINK} component={DirectLink} />
      <Route path={APP_ROUTES.MOBILELOGIN} component={MobileLogin} />
      <Route path={APP_ROUTES.PHONEPEPAYMENT} component={PaymentInitiation} />
      <Route path={APP_ROUTES.DIETPHONEPEPAYMENT} component={DietPaymentInitiation} />
      <Route path={APP_ROUTES.MEDPHARMA} component={MedPharma} />
      <Route path={APP_ROUTES.LABPHARMA} component={LabPharma} />
      <Route path={APP_ROUTES.ORDERREPORT} component={OrderReport} />
      <Route path={APP_ROUTES.EMERGENCYQR} component={EmergencyQR} />
      <Route path={APP_ROUTES.HEALTHSUMMARY} component={HealthSummary} />
      <Route path={APP_ROUTES.NOTIFICATION} component={Notification} />
      <Route path={APP_ROUTES.SLOT} component={Slot} />
      <Route path={APP_ROUTES.VIDEOCALL} component={VideoConsult} />
      <Route path={APP_ROUTES.MAPPEDCLINICS} component={MappedClinics} />
      <Route path={APP_ROUTES.APPTCALENDAR} component={AppointmentCalender} />
      <Route path={APP_ROUTES.FAVMEDICINE} component={FavMedicine} />
      <Route path={APP_ROUTES.DIRECTJOINCALL} component={DirectJoinCall} />
      <Route path={APP_ROUTES.DEVICESETUP} component={DevicesSetup} />
      <Route path={APP_ROUTES.RPMACTIVITYREPORT} component={RpmBillingReport} />
      <Route path={APP_ROUTES.RPMTASKFREQUENCY} component={TaskFrequency} />
      <Route path={APP_ROUTES.RPMVITALPARAMS} component={VitalParameters} />
      <Route
        path={APP_ROUTES.RPMPATIENTPALLETTE}
        component={RpmPatientPallette}
      />
      <Route path={APP_ROUTES.PATIENTMONITORING} component={PatientMonitor} />
      <Route path={APP_ROUTES.RPMDASHBOARD} component={RpmDashboard} />
      <Route path={APP_ROUTES.RPMCLINICALNOTES} component={RpmClinicalNotes} />
      <Route path={APP_ROUTES.DIETCHART} component={Dietrician} />
      <Route path={APP_ROUTES.DIETPLAN} component={DietPlan} />
      <Route
        path={APP_ROUTES.RPMMEDICALRECORDS}
        component={RpmMedicalRecords}
      />
      <Route path={APP_ROUTES.RPMMEDICALHISTORY} component={ViewAllHistory} />
      <Route path={APP_ROUTES.CALLBACK} component={CallBackForm} />
      <Route
        path={APP_ROUTES.REQUESTAPPOINTMENTS}
        component={RequestAppointments}
      />
      <Route path={APP_ROUTES.INPATIENTS} component={InPatients} />
      <Route path={APP_ROUTES.INPATIENTDETAIL} component={InPatientsNew} />
      <Route path={APP_ROUTES.ICUWARDS} component={ICUWards} />
      <Route path={APP_ROUTES.OPERATIONTHEATRE} component={OperationTheatre} />
      <Route path={APP_ROUTES.EMERGENCY} component={EmergencyPage} />
      <Route path={APP_ROUTES.WARDS} component={WardsPage} />

      <Redirect from={`/`} to={APP_ROUTES.LOGINFORM} />
    </Switch>
    //  </Router>
  );
};

export { PageRouting };
